<template>
  <div class="modal_activation_list">
    <div class="modal_activation_list__header">
      <h4 class="title">
        {{ translate("client_request.activation_list") }}
      </h4>
    </div>

    <div class="modal_activation_list__body">

      <div
          class="response_table"
          v-for="([list_key, list], i) in sorted_lists"
          :key="list_key"
          v-if="!check_mno(list_key)"
      >
        <label>{{ list_key }}</label>
        <table>
          <thead>
            <tr>
              <th scope="col">
                {{ translate('client_request.simcard_list.msisdn') }}
              </th>
              <th>
                {{translate('client_request.simcard_list.device')}}
              </th>
              <th scope="col">
                {{ translate('client_request.simcard_list.iccid') }}
              </th>
          </tr>
          </thead>
          <tbody>
            <tr
                v-for="(simcard, key) in list"
                :key="key"
                class="simcard_item"
            >
              <td :data-label="translate('client_request.simcard_list.msisdn')">
                {{ simcard.msisdn }}
              </td>
              <td :data-label="translate('client_request.simcard_list.device')" class="device_name">
                <p> {{ simcard.device_fid }} </p>
                <p>{{ simcard.device_name }}</p>
              </td>
              <td :data-label="translate('client_request.simcard_list.iccid')">
                {{ simcard.iccid }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>


    </div>
    <div class="modal_activation_list__footer">
      <span
          class="btn btn-success btn-fill btn-wd"
      >
        {{ translate('btn.next') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>



export default {
  name: 'ActivationListsModal',
  props:[
    "lists"
  ],

  data () {
    return {

    }
  },
  computed:{
    sorted_lists() {
      const src = this.lists || {};
      return Object.keys(src)
          .sort((a, b) =>
              String(a).toLowerCase().localeCompare(String(b).toLowerCase(), "ru")
          )
          .map((k) => [k, src[k]]);
    },
  },

  methods: {
    check_mno(mno){
      const disabled_mno = [""]
      return disabled_mno.indexOf(mno.toLowerCase()) > -1
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .modal_activation_list{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      height: 600px;
      overflow-y: auto;
      .response_table{
        height: auto;
        .device_name{
          a,p{
            font-size: 12px;
            margin-bottom: 0;
          }
        }
      }


    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }


</style>
